import React, { Component } from 'react';
import axios from 'axios';
import Image from 'next/image';

import Thanks from './Thanks';

import { Input, Radio, Select, Textarea } from './forms/input';

class Offer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      formdata: {},
      showThanks: false,
      loadedThanks: false,
    };

    this.handleChange = this.handleChange.bind(this);

    this.hideThanksModal = this.hideThanksModal.bind(this);
  }

  handleChange(param, value) {
    var formdata = this.state.formdata;

    this.setState(prevState => {
      let formdata = Object.assign({}, prevState.formdata);
      formdata[param] = value;
      return { formdata };
    });
  }
  hideThanksModal() {
    this.setState({
      loadedThanks: false,
      showThanks: false,
    });
    document.body.style.overflow = 'auto';

    document.body.style.overflowX = 'hidden';
  }
  onSubmit(e) {
    e.preventDefault();

    var that = this;

    var form_data = new FormData(e.target);

    for (var key in this.state.formdata) {
      form_data.append(key, this.state.formdata[key]);
    }

    form_data.append('country', this.props.country);

    // that.props.hide();

    // that.setState({showThanks:true});

    document.body.style.overflow = 'hidden';

    axios.post('https://mailer.weprodigi.com/api/v1/social-marketing', form_data).then(response => {
      // that.setState({loadedThanks:true});
      window.location.href = 'https://weprodigi.com/thank-you';
    });
  }

  render() {
    return (
      <>
        <div
          className={
            'fixed z-900 bg-navbar w-full h-full left-0 top-0 right-0 bottom-0 items-center justify-center' +
            ' ' +
            (this.props.show && !this.state.showThanks ? 'flex' : 'hidden')
          }
        >
          <div className="absolute left-0 top-0 w-full h-full" onClick={this.props.hide}></div>

          <div className="relative transform w-11/12 max-w-screen-md max-h-screen-md bg-gray border border-gray-transparent rounded-5 md:scale-60 2xl:scale-100">
            <div
              onClick={this.props.hide}
              className="absolute -right-12 -top-12 bg-purple text-white w-30 h-30 text-21 rounded-full flex items-center justify-center cursor-pointer select-none"
            >
              <span className="font-bold">X</span>
            </div>

            <div className="py-23 px-50">
              <p className="text-purple uppercase text-24 text-center font-black leading-none">Get a custom proposal</p>
              <p className="text-black normal-case text-16 text-center font-black mt-5 mb-15 leading-none">
                {this.props.service || 'Social Media Marketing'}
              </p>

              <p className="text-black text-1a4">
                Kindly take a few minutes and complete the form to help us further understand your organization’s needs and provide a more relevant
                proposal.
              </p>

              <form id="offer-form" method="POST" onSubmit={e => this.onSubmit(e)}>
                <div className="mt-10">
                  <div className="mb-10">
                    <p className="text-16 text-purple font-medium mb-10">1. Tell us about your company</p>

                    <p className="text-14 text-black mb-5">Company Name*</p>

                    <div className="mb-10">
                      <Input type="text" name="company-name" bg="bg-gray-light" required={true} onChange={this.handleChange}></Input>
                    </div>

                    <p className="text-14 text-black mb-5">Does your company have a website?*</p>

                    <div className="flex flex-row my-10">
                      <div className="form-group mr-30">
                        <label className="relative pl-30 cursor-pointer text-14 flex items-center">
                          <input
                            className="absolute cursor-pointer opacity-0"
                            onChange={() => this.handleChange('has-website', 'Yes')}
                            type="radio"
                            name="has-website"
                            value="Yes"
                          ></input>
                          <span className="checkmark absolute left-0 w-20 h-20 border border-purple rounded-sm"></span>
                          Yes
                        </label>
                      </div>

                      <div className="form-group mr-30">
                        <label className="relative pl-30 cursor-pointer text-14 flex items-center">
                          <input
                            className="absolute cursor-pointer opacity-0"
                            onChange={() => this.handleChange('has-website', 'No')}
                            type="radio"
                            name="has-website"
                            value="No"
                          ></input>
                          <span className="checkmark absolute left-0 w-20 h-20 border border-purple rounded-sm"></span>
                          No
                        </label>
                      </div>
                    </div>

                    {this.state.formdata['has-website'] == 'Yes' && (
                      <div>
                        <p className="text-14 text-black mb-5">Website URL*</p>

                        <div className="mb-10">
                          <Input type="text" name="website" bg="bg-white" required={true} onChange={this.handleChange}></Input>
                        </div>
                      </div>
                    )}
                  </div>

                  <div className="mb-10">
                    <p className="text-16 text-purple font-medium mb-10">2. Tell us about your project</p>

                    <p className="text-14 text-black mb-5">Describe your project and needs</p>

                    <div className="mb-10">
                      <Textarea
                        type="text"
                        name="description"
                        bg="bg-gray-light"
                        required={false}
                        rows={2}
                        placeholder=""
                        onChange={this.handleChange}
                      ></Textarea>
                    </div>
                  </div>

                  <div className="mb-10">
                    <p className="text-16 text-purple font-medium mb-10">3. Tell us how to contact you</p>

                    <p className="text-14 text-black mb-5">Name*</p>

                    <div className="mb-10">
                      <Input type="text" name="name" bg="bg-gray-light" required={true} onChange={this.handleChange}></Input>
                    </div>

                    <div className="grid grid-cols-2 gap-10">
                      <div>
                        <p className="text-14 text-black mb-5">Email*</p>

                        <div className="mb-10">
                          <Input type="text" name="email" bg="bg-gray-light" required={true} onChange={this.handleChange}></Input>
                        </div>
                      </div>

                      <div>
                        <p className="text-14 text-black mb-5">Number</p>

                        <div className="mb-10">
                          <Input type="text" name="number" bg="bg-gray-light" required={false} onChange={this.handleChange}></Input>
                        </div>
                      </div>
                    </div>

                    <p className="text-14 text-black mb-5">What’s the best way to contact you?</p>

                    <div className="flex flex-row my-10">
                      <div className="form-group mr-30">
                        <label className="relative pl-30 cursor-pointer text-14 flex items-center">
                          <input
                            className="absolute cursor-pointer opacity-0"
                            onChange={() => this.handleChange('contact-via', 'Email')}
                            type="radio"
                            name="contact-via"
                            value="Email"
                          ></input>
                          <span className="checkmark absolute left-0 w-20 h-20 border border-purple rounded-sm"></span>
                          Email
                        </label>
                      </div>

                      <div className="form-group mr-30">
                        <label className="relative pl-30 cursor-pointer text-14 flex items-center">
                          <input
                            className="absolute cursor-pointer opacity-0"
                            onChange={() => this.handleChange('contact-via', 'Phone')}
                            type="radio"
                            name="contact-via"
                            value="Phone"
                          ></input>
                          <span className="checkmark absolute left-0 w-20 h-20 border border-purple rounded-sm"></span>
                          Phone
                        </label>
                      </div>

                      <div className="form-group mr-30">
                        <label className="relative pl-30 cursor-pointer text-14 flex items-center">
                          <input
                            className="absolute cursor-pointer opacity-0"
                            onChange={() => this.handleChange('contact-via', 'Both')}
                            type="radio"
                            name="contact-via"
                            value="Both"
                          ></input>
                          <span className="checkmark absolute left-0 w-20 h-20 border border-purple rounded-sm"></span>
                          Both
                        </label>
                      </div>
                    </div>
                    <p className="text-14 text-black mb-5">Send NDA?</p>

                    <div className="flex flex-row my-10">
                      <div className="form-group mr-30">
                        <label className="relative pl-30 cursor-pointer text-14 flex items-center">
                          <input
                            className="absolute cursor-pointer opacity-0"
                            onChange={() => this.handleChange('nda', 'Yes')}
                            type="radio"
                            name="nda"
                            value="Yes"
                          />
                          <span className="checkmark absolute left-0 w-20 h-20 border border-purple rounded-sm" />
                          Yes
                        </label>
                      </div>

                      <div className="form-group mr-30">
                        <label className="relative pl-30 cursor-pointer text-14 flex items-center">
                          <input
                            className="absolute cursor-pointer opacity-0"
                            onChange={() => this.handleChange('nda', 'No')}
                            type="radio"
                            name="nda"
                            value="No"
                          />
                          <span className="checkmark absolute left-0 w-20 h-20 border border-purple rounded-sm" />
                          No
                        </label>
                      </div>
                    </div>
                  </div>

                  <input type="hidden" name="country" value={this.props.country}></input>

                  <div className="col-span-2">
                    <button
                      id="offer-submit"
                      type="submit"
                      className="cursor-pointer mx-auto text-white bg-green text-18 mt-10 px-23 py-3 rounded-5 block "
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </form>

              <div className="mt-23">
                <p className="text-9 md:text-12">
                  After receiving the request, one of our account managers will contact you and confirm it. Based on the provided information, our SMM
                  department will create a customized proposal, which you will receive within 1-3 days via email. Our specialists are available 24/7
                  and are ready to arrange a call with you at any convenient time.
                </p>
              </div>
            </div>
          </div>
        </div>
        <Thanks show={this.state.showThanks} loaded={this.state.loadedThanks} hide={this.hideThanksModal}>
          Thank you for reaching out to us! One of our account managers will contact you and confirm your request. If you don’t receive an email from
          us within 24 hours please check your Spam Box.
        </Thanks>
      </>
    );
  }
}
export default Offer;
